<template>
    <a class="card-wrap"
        @mousemove="handleMouseMove"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
        ref="card"
        :href="link">
        <div class="card"
            :style="cardStyle">
            <div class="card-bg" :style="[cardBgTransform, cardBgImage]"></div>
            <div class="card-info">
                <slot name="content"></slot>
                <slot name="header"></slot>
            </div>
        </div>
    </a>
</template>

<script>
import { ref, computed, onMounted } from 'vue'

export default {
    props: {
        image: {
            type: String,
            default: ''
        },
        link: {
            type: String,
            default: ''
        },
    },

    setup(props) {
        const width = ref(0)
        const height = ref(0)
        const mouseX = ref(0)
        const mouseY = ref(0)
        const mouseLeaveDelay = ref(null)
        const card = ref(null)
        const animate = ref(false)

        const mousePX = computed(() => mouseX.value / width.value)
        const mousePY = computed(() => mouseY.value / height.value)
        const cardStyle = computed(() => {
            const rX = mousePX.value * 30
            const rY = mousePY.value * -30
            return {
                transform: `rotateY(${rX}deg) rotateX(${rY}deg)`
            };
        })
        const cardBgTransform = computed(() => {
            const tX = mousePX.value * -40;
            const tY = mousePY.value * -40;
            return {
                transform: `translateX(${tX}px) translateY(${tY}px)`
            }
        })
        const cardBgImage = computed(() => {
            return {
                backgroundImage: `url(${props.image})`
            }
        })

        function handleMouseMove(e) {
            if (!animate.value) return
            mouseX.value = e.pageX - card.value.offsetLeft - width.value/2
            mouseY.value = e.pageY - card.value.offsetTop - height.value/2
        }

        function handleMouseEnter() {
            if (!animate.value) return
            clearTimeout(mouseLeaveDelay.value)
        }

        function handleMouseLeave() {
            if (!animate.value) return
            mouseLeaveDelay.value = setTimeout(() => {
                mouseX.value = 0
                mouseY.value = 0
            }, 1000)
        }

        function debounce(callback, wait) {
            let timeoutId = null
            return (...args) => {
                window.clearTimeout(timeoutId)
                timeoutId = window.setTimeout(() => {
                callback.apply(null, args)
                }, wait)
            }
        }

        function toggleAnimate() {
            if (matchMedia('(min-width: 1024px)').matches) return animate.value = true
            animate.value = false
        }

        onMounted(() => {
            width.value = card.value.offsetWidth
            height.value = card.value.offsetHeight
            toggleAnimate()
            window.addEventListener('resize', debounce(toggleAnimate), 1000)
        })

        return {
            handleMouseMove,
            handleMouseEnter,
            handleMouseLeave,
            cardStyle,
            card,
            cardBgTransform,
            cardBgImage
        }
    }
}
</script>
